import React from "react";

const Shipping = () => {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Shipping Policy</h1>
      <p className="mb-2">
       Opposite Bird Hospital, Jain Mandir wali Gali, Sadar Bazar <strong></strong>.
      </p>
      <p className="mb-2">
        Standard shipping usually takes <strong>5–7 business days</strong>.
        Expedited shipping options are available at checkout.
      </p>
      <p className="mb-2">
        Once shipped, you will receive an email with tracking information.
      </p>
    </div>
  );
};

export default Shipping;